import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-271" data-mp="21ah7un2v9h6q" />);
}